import { render, staticRenderFns } from "./StaffChangeRiskOverview.vue?vue&type=template&id=91b1df90&scoped=true"
import script from "./StaffChangeRiskOverview.vue?vue&type=script&lang=js"
export * from "./StaffChangeRiskOverview.vue?vue&type=script&lang=js"
import style0 from "./StaffChangeRiskOverview.vue?vue&type=style&index=0&id=91b1df90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91b1df90",
  null
  
)

export default component.exports